import { assign, get } from 'lodash';
import { defineMessages } from 'react-intl';
import { single } from 'validate.js';
import {
  extractCardExpirationParts,
  isExpired,
  isMonthInvalid,
} from '../../lib/card-functions';
import { formatMessage } from '../../lib/intl';

const i18n = defineMessages({
  selectCard: {
    id: 'singlePayerForm.errors.selectCard',
    defaultMessage: 'Select a credit card option',
  },
  badPasswordLength: {
    id: 'singlePayerForm.errors.badPasswordLength',
    defaultMessage: 'Must contain at least 8 characters.',
  },
  badEmail: {
    id: 'singlePayerForm.errors.badEmail',
    defaultMessage: 'This is not a valid email.',
  },
  youHaveAnAccount: {
    id: 'singlePayerForm.errors.youHaveAnAccount',
    defaultMessage: 'You already have an account, please sign in.'
  },
  isRequired: {
    id: 'singlePayerForm.errors.isRequired',
    defaultMessage: 'This field is required.',
  },
  expired: {
    id: 'singlePayerForm.errors.expired',
    defaultMessage: 'Cannot be expired',
  },
  invalidMonth: {
    id: 'singlePayerForm.errors.invalidMonth',
    defaultMessage: 'Invalid month',
  },
});

export default (values, props) => {
  const errors = { card: {} };
  const translate = formatMessage(props.intl);

  if (values.__isSignIn) return validateSignin(values, props);

  if (values.card && values.card.paymentSourceId === '') {
    errors.card.paymentSourceId = translate(i18n.selectCard);
  }

  if (values.card && values.card.paymentSourceId === 'new') {
    if (!values.card || !values.card.fullName) {
      errors.card.fullName = ' ';
    }
    if (!values.card || !values.card.zipCode) {
      errors.card.zipCode = ' ';
    }
    if (!values.card || !values.card.expDate) {
      errors.card.expDate = translate(i18n.isRequired);
    } else {
      const expParts = extractCardExpirationParts(values.card.expDate);
      if (isExpired(values.card.expDate)) {
        errors.card.expDate = translate(i18n.expired)
      } else if (isMonthInvalid(expParts)) {
        errors.card.expDate = translate(i18n.invalidMonth);
      }
    }
  }

  if (!props.user) {
    assign(errors, validateAuth(values, props));
  }

  return errors;
};

const validateSignin = (values = {}, props) => {
  let errors = {};
  const emailError = validateEmail(values.email, formatMessage(props.intl));

  if (!values.password || values.password.length === 0) {
    errors = { ...emailError, password: formatMessage(props.intl)(i18n.isRequired) };
  } else {
    errors = { ...emailError };
  }

  return errors;
}

const validateAuth = (values, props) => {
  const emailError = validateEmail(values.email, formatMessage(props.intl));

  if (values.guestPassword && values.guestPassword.guest) {
    return { ...emailError };
  } else {
    return { ...emailError, ...validatePassword(values, formatMessage(props.intl)) };
  }
}

const validatePassword = (values, formatMessage) => {
  const isGuestPassword = get(values, 'guestPassword.guest');
  const password = get(values, 'password');
  const guestPassword = get(values, 'guestPassword.password');

  if (password && password.length < 8) {
    return { password: formatMessage(i18n.badPasswordLength) };
  }

  if (isGuestPassword === false) {
    if (!guestPassword || !guestPassword.length) {
      return { guestPassword: formatMessage(i18n.isRequired) };
    }
    if (guestPassword && guestPassword.length < 8) {
      return { guestPassword: formatMessage(i18n.badPasswordLength) };
    }
  }

  return {};
};

const validateEmail = (email, formatMessage) => {
  if (!email || email === '') return { email: formatMessage(i18n.isRequired) };
  if (single(email, { email: true, presence: true })) {
    return { email: formatMessage(i18n.badEmail) };
  }
}



// WEBPACK FOOTER //
// ./src/desktop/pages/single-payer-payment/validate.js